var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFavoritesDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#FFB142"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.324 8.20232L18.5549 12.8422C18.6064 12.9501 18.7094 13.022 18.8124 13.04L23.7033 13.8493C23.9951 13.9033 24.098 14.2629 23.8921 14.4787L20.3912 18.1295C20.3054 18.2194 20.2711 18.3273 20.2882 18.4532L21.0776 23.5787C21.1291 23.8664 20.8202 24.1002 20.58 23.9563L16.1695 21.5824C16.0666 21.5285 15.9464 21.5285 15.8435 21.5824L11.433 23.9563C11.1756 24.1002 10.8839 23.8664 10.9354 23.5787L11.7248 18.4532C11.7419 18.3453 11.7076 18.2194 11.6218 18.1295L8.10377 14.4608C7.89783 14.245 8.01796 13.8853 8.29254 13.8313L13.1835 13.022C13.2865 13.0041 13.3894 12.9321 13.4409 12.8242L15.689 8.20232C15.8263 7.93256 16.1867 7.93256 16.324 8.20232Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoritesDelete);
export default __webpack_public_path__ + "static/media/favorites-delete.9a2a48de.svg";
export { ForwardRef as ReactComponent };